import { twMerge } from "tailwind-merge";

export function Table({ children, className, ...props }: React.HTMLAttributes<HTMLTableElement>) {
  return (
    <div
      className={twMerge(
        "text-charcoal-600 table-fixed overflow-hidden overflow-y-scroll rounded-md border border-slate-300",
        className,
      )}
      {...props}
    >
      <table className="w-full">{children}</table>
    </div>
  );
}

export function TableHead({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <thead className={twMerge("text-left", className)} {...props}>
      {children}
    </thead>
  );
}

export function TableBody({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableSectionElement>) {
  return (
    <tbody className={twMerge("[&_tr:hover]:bg-slate-100", className)} {...props}>
      {children}
    </tbody>
  );
}

export function TableRow({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableRowElement>) {
  return (
    <tr className={twMerge("cursor-pointer", className)} {...props}>
      {children}
    </tr>
  );
}

export function TableHeader({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableCellElement>) {
  return (
    <th
      className={twMerge(
        "z-1 text-charcoal-400 sticky top-0 whitespace-nowrap border-b bg-slate-100 px-1.5 py-2 text-[11px] font-medium uppercase tracking-wide first-of-type:pl-3 last-of-type:pr-3",
        className,
      )}
      {...props}
    >
      {children}
    </th>
  );
}

export function TableCell({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableCellElement>) {
  return (
    <td
      className={twMerge(
        "whitespace-nowrap px-1.5 py-2 align-baseline text-xs font-medium first-of-type:pl-3 last-of-type:pr-3",
        className,
      )}
      {...props}
    >
      {children}
    </td>
  );
}

export function TruncatedTableCell({
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLTableCellElement>) {
  return (
    <TableCell className={twMerge("whitespace-normal", className)} {...props}>
      <div className="line-clamp-1">{children}</div>
    </TableCell>
  );
}
